import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login.vue'
import FormList from '@/components/form_list.vue'
import Registe from '@/components/registe.vue'
import UserForm from '@/components/user_form.vue'
import ImportExcel from '@/components/import_excel.vue'
import ExcelPreview from '@/components/excel_preview.vue'
import MakeForm from '@/components/make_form.vue'
import ReadMe from '@/components/read_me.vue'

import TableView from '@/components/tableView.vue'

// 核对数据表
import ValidationFormList from '@/components/validation_form_list.vue'
import ImportDataExcel from '@/components/import_data_excel.vue'
import ExcelDataPreview from '@/components/excel_data_preview.vue'
import ExcelDataImportFinalStep from '@/components/excel_data_import_final_step.vue'
import InputerList from '@/components/inputer_list.vue'
import InputerListDetail from '@/components/inputer_list_detail.vue'
import SetValidCondition from '@/components/set_valid_condition.vue'

import FormDetail from '@/components/form_detail.vue'

import BrowseAllData from '@/components/browse_all_data.vue'
import AddRecord from '@/components/add_record.vue'

import InvitedFormList from '@/components/invited_form_list.vue'

import ImportChecking from '@/components/import_checking.vue'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/form_list',
      name: 'formList',
      component: FormList,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/registe',
      name: 'registe',
      component: Registe,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/user_form',
      name: 'user_form',
      component: UserForm,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/import_excel',
      name: 'import_excel',
      component: ImportExcel,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/excel_preview',
      name: 'excel_preview',
      component: ExcelPreview,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/table_view',
      name: 'table_view',
      component: TableView,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/make_form',
      name: 'make_form',
      component: MakeForm,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/read_me',
      name: 'read_me',
      component: ReadMe,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/validation_form_list',
      name: 'validation_form_list',
      component: ValidationFormList,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/import_data_excel',
      name: 'import_data_excel',
      component: ImportDataExcel,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/excel_data_preview',
      name: 'excel_data_preview',
      component: ExcelDataPreview,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/excel_data_import_final_step',
      name: 'excel_data_import_final_step',
      component: ExcelDataImportFinalStep,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/inputer_list',
      name: 'inputer_list',
      component: InputerList,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/inputer_list_detail',
      name: 'inputer_list_detail',
      component: InputerListDetail,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/set_valid_condition',
      name: 'set_valid_condition',
      component: SetValidCondition,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/form_detail',
      name: 'form_detail',
      component: FormDetail,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/browse_all_data',
      name: 'browse_all_data',
      component: BrowseAllData,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/add_record',
      name: 'add_record',
      component: AddRecord,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/invited_form_list',
      name: 'invited_form_list',
      component: InvitedFormList,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    },
    {
      path: '/import_checking',
      name: 'import_checking',
      component: ImportChecking,
      meta: {
        title: '在线填表|收集数据|收照片|收文档|收学生资料|打卡填表|签到填表|多人填表|导出excel'
      }
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js